"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Timeline =
/*#__PURE__*/
function (_Component) {
  _inherits(Timeline, _Component);

  function Timeline(props) {
    var _this;

    _classCallCheck(this, Timeline);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Timeline).call(this, props));
    _this.state = {
      data: _this.props.data
    };
    return _this;
  }

  _createClass(Timeline, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data) {
        this.setState({
          data: nextProps.data
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var input = document.getElementById("message-text");
      input.addEventListener("keyup", function (event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          document.getElementById("submit-btn").click();
        }
      });
    }
  }, {
    key: "post",
    value: function post() {
      var currentdate = new Date().toLocaleString();
      ;
      var messageText = document.getElementById('message-text').value;
      var item = {
        updateBy: this.props.userName,
        profileImage: this.props.userProfileImage,
        timestamp: currentdate,
        status: {
          color: 'blue-status-color',
          icon: 'fa fa-comment',
          label: 'Comment'
        },
        message: messageText
      };
      this.state.data.unshift(item);
      this.setState({
        data: this.state.data
      });
      document.getElementById('message-text').value = '';
      this.props.onChange(this.state.data);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", {
        className: "time-line-widget"
      }, _react.default.createElement("ul", {
        className: "timeline-list"
      }, _react.default.createElement("li", {
        className: "timeline-input"
      }, _react.default.createElement("div", {
        className: "image-block inline"
      }, _react.default.createElement("img", {
        alt: "",
        src: this.props.userProfileImage
      })), _react.default.createElement("div", {
        className: "input-block inline"
      }, _react.default.createElement("div", {
        className: "input-btn-wrapper"
      }, _react.default.createElement("input", {
        id: 'message-text',
        placeholder: 'Type a message',
        className: "form-control",
        type: "text"
      }), _react.default.createElement("button", {
        id: "submit-btn",
        type: "button",
        className: "select-btn",
        onClick: function onClick() {
          return _this2.post();
        }
      }, _react.default.createElement("span", {
        className: "fa fa-paper-plane"
      })))))), _react.default.createElement("ul", {
        className: "timeline-list"
      }, this.state.data.map(function (item, index) {
        return _react.default.createElement("li", {
          className: "timeline-history"
        }, _react.default.createElement("div", {
          className: "image-block inline"
        }, _react.default.createElement("img", {
          alt: "",
          src: item.profileImage
        })), _react.default.createElement("div", {
          className: "info-block inline"
        }, _react.default.createElement("div", {
          className: "info-head"
        }, _react.default.createElement("span", {
          className: "title"
        }, item.updateBy), _react.default.createElement("span", {
          className: "date-time"
        }, item.timestamp)), _react.default.createElement("div", {
          className: "info-body"
        }, _react.default.createElement("div", {
          className: "status-msg"
        }, _react.default.createElement("i", {
          className: "".concat(item.status.icon, " + ").concat(item.status.color),
          "aria-hidden": "true"
        }), _react.default.createElement("span", null, " ", item.status.label)), _react.default.createElement("div", {
          className: "message-container"
        }, item.message))));
      })));
    }
  }]);

  return Timeline;
}(_react.Component);

var _default = Timeline;
exports.default = _default;